module.exports = __webpack_public_path__ + "static/media/PROFILE_MOTIVATED.02760b0b.md";